import { ClearSearch } from "source/app/presentation/MainPanel/Workflows/SearchNodes/Clear/ClearSearch";
import { AddNodeAsync } from "source/app/services/Workflows/ChangeData/AddNodeAsync";
import { RefreshVisibleWorkflowNodesAsync } from "../../Helpers/RefreshVisibleWorkflowNodes";

export async function SaveNodeAsync(
    name: string,
    parentid: number,
    canAddNode: boolean
) {
    if (name === "") {
        return;
    }

    if (!canAddNode) {
        return;
    }

    await AddNodeAsync({
        name,
        parentid,
    });

    await RefreshVisibleWorkflowNodesAsync();
    ClearSearch();
}
